module.exports = __webpack_public_path__ + "img/italian-chicken-soup.08593656.jpg";